'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/screensavers", "/screensavers/list");

  $stateProvider
    .state('screensavers', {
      url: '/screensavers',
      template: require('./screenSaver.html'),
      authenticate: true
    })
    .state('screensavers.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'ScreenSaverListController',
      controllerAs: 'ssListCtrl'
    })
    .state('screensavers.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'ScreenSaverAddController',
      controllerAs: 'ssAddCtrl'
    })
    .state('screensavers.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'ScreenSaverEditController',
      controllerAs: 'ssEditCtrl'
    })
    .state('screensavers.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'ScreenSaverShowController',
      controllerAs: 'ssShowCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/screenSaver/screenSaver.routes.js